import React from "react";

const useInventoryLocationHook = (data) => {
    const [inventoryLocation, setInventoryLocation] = React.useState({
        ...data,
        is_auto_assignable: !!data?.is_auto_assignable,
        country: data?.country || "US",
    });
    return [inventoryLocation, setInventoryLocation];
}

export default useInventoryLocationHook;